<script setup>
import { ref } from 'vue';
import { useCcm19Global } from '../../useCcm19Global';
import CookieReset from './../CookieReset.vue';

const content = ref({
    questions_phrase_key: 'homepage_career_bullets',
    text_phrase_key: 'homepage_career_texts',
    videoId: '8atZtsEgkPM',
    video: 'https://www.youtube.com/embed/8atZtsEgkPM?si=XqbMCwK-IucjRcU4'
});

const { onReady, youtube } = useCcm19Global();
onReady(() => {});
</script>

<template>
    <div class="container mx-auto pt-32">
        <div class="flex flex-col md:flex-row gap-12 items-start justify-center">
            <!-- Video Section -->
            <div class="w-full md:w-1/2">
                <div v-if="youtube">
                    <YoutubePlayer :source="content.videoId" />
                </div>
                <div v-else>
                    <div class="relative w-full aspect-video rounded-lg overflow-hidden shadow-lg bg-gray-100 flex items-center justify-center">
                        <div class="absolute inset-0 bg-gradient-to-br from-gray-200 via-gray-100 to-gray-50"></div>
                        <div class="relative z-10 flex flex-col items-center gap-3 px-6 text-center">
                            <div class="w-16 h-16 rounded-full bg-white shadow flex items-center justify-center">
                                <i class="fi fi-rr-play text-gray-400 text-3xl"></i>
                            </div>
                            <p class="text-sm text-gray-600 font-medium">{{ $t('scampage.blockedVideo') }}</p>

                            <CookieReset class="mt-2" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="w-full md:w-1/2 text-lg">
                <h3 v-html="$t('homepage_career_head')"></h3>

                <div class="pt-6">
                    <div v-for="(question, index) in $t(content.questions_phrase_key, { returnObjects: true })" :key="index" class="flex items-center gap-3">
                        <div class="w-6 text-blue">
                            <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512">
                                <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M416 128L192 384l-96-96" />
                            </svg>
                        </div>
                        <div>{{ question }}</div>
                    </div>
                </div>

                <div class="py-6">
                    <p v-for="(paragraph, index) in $t(content.text_phrase_key, { returnObjects: true })" :key="index" class="mb-3">
                        {{ paragraph }}
                    </p>
                </div>

                <div class="pt-6">
                    <FormButton
                        :value="$t('homepage_career_btn')"
                        styling="xl bg-blue text-lg text-white w-full py-6"
                        link="https://hopf-klinkmueller-capital-management.workwise.io/"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
